<template>
  <div class="relative-position">
    <q-input
      @focus="openDatePopup()"
      @update:model-value="$emit('update:modelValue', $event)"
      :label="label"
      outlined
      dense
      :model-value="modelValue"
      clearable
      @clear="clearField"
      ref="input"
    >
      <template v-slot:prepend>
        <q-popup-proxy ref="popup" cover transition-show="scale" transition-hide="scale">
          <q-date :model-value="modelValue" @update:model-value="inputValue($event)" mask="YYYY-MM-DD HH:mm">
            <div class="row items-center justify-end">
              <q-btn v-close-popup label="Close" color="primary" flat />
            </div>
          </q-date>
        </q-popup-proxy>
      </template>
      <template v-slot:append>
        <span class="block" style="min-width: 26px"></span>
      </template>
    </q-input>
    <q-icon size="24px" name="access_time" class="time-picker cursor-pointer">
      <q-popup-proxy cover transition-show="scale" transition-hide="scale">
        <q-time
          :model-value="modelValue"
          @update:model-value="$emit('update:modelValue', $event)"
          mask="YYYY-MM-DD HH:mm"
          format24h
        >
          <div class="row items-center justify-end">
            <q-btn v-close-popup label="Close" color="primary" flat />
          </div>
        </q-time>
      </q-popup-proxy>
    </q-icon>
  </div>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    modelValue: {
      type: [String, undefined],
    },
    label: {
      type: String,
    },
  },
  methods: {
    openDatePopup() {
      this.$refs.popup?.hide();
      this.$refs.popup?.show();
    },
    inputValue(data) {
      this.$emit('update:modelValue', data);
      this.$refs.popup?.hide();
    },
    clearField() {
      this.$refs.popup?.hide();
      this.$refs.input.blur();
      this.$emit('clear');
    },
  },
};
</script>

<style lang="scss" scoped>
.time-picker {
  position: absolute;
  right: 12px;
  top: 16px;
  color: #6d6e70;
}
</style>
